import { Cirus } from "@/classes/Http";
import { AxiosResponse } from "axios";


export class WithdrawAccount {
    constructor (public id?: string, public IBAN?: string, owner_name?: string){}
}

export function getUserWithdrawAccounts(): Promise<AxiosResponse<WithdrawAccount[]>>{
    const query = '/user/withdraw-accounts';
    return Cirus.get(query);
}